import API from './API';

export default {

    findCultures() {
        return API.get("/cultures")
    }

}
